import { FC, useMemo } from 'react'
import styles from 'components/features/socialFeed/SocialInsightList/SocialInsightList.styl'
import { SocialInsightCard } from 'components/features/socialFeed/SocialInsightCard/SocialInsightCard'
import { SocialInsight } from 'components/features/socialFeed/SocialInsight/SocialInsight'
import { useStoreSelector } from 'helpers/reactReduxHelpers'
import { createFilteredOpportunitiesSelector as createFilteredOpportunitiesSelector } from 'selectors/oppertunitiesSelectors'
import Insight from 'components/features/insights/Insight/Insight'
import { WithPlacement } from 'interfaces/insights'
import { OpportunityPlacement, WithSelectedCategoryId } from 'interfaces/opportunities'
import { useIsPublicPage } from 'helpers/pageHelpers'

type SocialInsightListProps =
  & WithPlacement<OpportunityPlacement>
  & WithSelectedCategoryId

export const SocialInsightList: FC<SocialInsightListProps> = (props) => {
  const { placement } = props
  const insightsSelector = useMemo(() => createFilteredOpportunitiesSelector(placement), [placement])
  const insights = useStoreSelector((state) => insightsSelector(state, props))

  const isPublic = useIsPublicPage()

  return (
    <div className={ styles.socialInsightList }>
      { insights && insights.map((insight, index) => {
        if (!('socialInsightUid' in insight)) {
          return null
        }

        if (!insight.socialInsightUid && insights.length === 1) {
          return (
            <div className={ styles.insight } key={ index }>
              <SocialInsightCard noPadding>
                <Insight insight={ insight } noCard />
              </SocialInsightCard>
            </div>
          )
        }

        if ('socialInsightUid' in insight) {
          return (
            <div className={ styles.insight } key={ index }>
              <SocialInsightCard>
                <SocialInsight
                  uid={ insight.socialInsightUid }
                  index={ index }
                  isDismissible={ !isPublic }
                />
              </SocialInsightCard>
            </div>
          )
        }
        return null
      })}
    </div>
  )
}
